import { Controller } from "@hotwired/stimulus"
import { Notyf } from 'notyf';
import 'notyf/notyf.min.css';

export default class extends Controller {
  static values = {
    notice: String,
    alert: String
  }
  connect() {
    const notyf = new Notyf({ duration: 3000, ripple: true, position: { x: "right", y: "top" } });

    const flashNotice = this.noticeValue;
    const flashAlert = this.alertValue;

    if (flashNotice) {
      notyf.success(flashNotice)
    }

    if (flashAlert) {
      notyf.error(flashAlert)
    }
  }
}
